import { formatCodeableConcept, type WithId } from '@medplum/core';
import type { Condition } from '@medplum/fhirtypes';
import { format, parseISO } from 'date-fns';
import { useTranslation } from 'react-i18next';
import { DATE_FORMATS } from '../../utils/date';
import { type PromotionStatus, RecordListItem } from './RecordListItem';

export type ConditionsListProps = {
  conditions: WithId<Condition>[];
  onSelectCondition?: (id: string) => void;
  selectedConditionId?: string;
  onPromotionClick?: (id: string) => void;
  getPromotionStatus?: (id: string) => PromotionStatus;
};

export const ConditionsList = ({
  conditions,
  onSelectCondition,
  selectedConditionId,
  onPromotionClick,
  getPromotionStatus,
}: ConditionsListProps): React.ReactElement => {
  const { t } = useTranslation('records');

  return (
    <div className="mx-auto w-full max-w-4xl">
      <div className="space-y-2">
        {conditions.length > 0 ? (
          conditions.map((condition) => {
            const onsetDate = condition.onsetDateTime
              ? format(parseISO(condition.onsetDateTime), DATE_FORMATS.DATE)
              : condition.onsetPeriod?.start
                ? format(parseISO(condition.onsetPeriod.start), DATE_FORMATS.DATE)
                : t('unknown');

            return (
              <RecordListItem
                key={condition.id}
                title={condition.code ? formatCodeableConcept(condition.code) : t('unknownCondition')}
                description={t('onsetDateValue', { date: onsetDate })}
                onClick={onSelectCondition ? (): void => onSelectCondition(condition.id) : undefined}
                selected={selectedConditionId === condition.id}
                onPromotionClick={onPromotionClick ? (): void => onPromotionClick(condition.id) : undefined}
                promotionStatus={getPromotionStatus?.(condition.id)}
              />
            );
          })
        ) : (
          <p className="py-8 text-center text-sm text-muted-foreground">{t('noConditionsFound')}</p>
        )}
      </div>
    </div>
  );
};
